import { Controller } from '@hotwired/stimulus'

// Job notes modal inside the work list table. Lazily initializes TinyMCE once
// the dialog opens, submits the note with fetch, and refreshes the modal list
// plus the notes row under the job in the work list table.
export default class extends Controller {
  static targets = ['form', 'errors']
  static values = { jobId: Number }

  prepare() {
    const id = `job_note_content_${this.jobIdValue}`
    setTimeout(() => {
      if (window.tinymce && !window.tinymce.get(id)) {
        window.tinymce.init({
          selector: `#${id}`,
          height: 200,
          menubar: false,
          license_key: 'gpl',
          plugins: ['lists'],
          toolbar: 'bold italic underline | forecolor backcolor | fontsize | bullist numlist',
          content_style: "body { font-family: Inter, 'Segoe UI', system-ui, sans-serif; font-size: 14px; color: #101f3c; }"
        })
      }
    }, 50)
  }

  async submit(event) {
    event.preventDefault()
    if (window.tinymce) window.tinymce.triggerSave()

    // rails-ujs disables submit buttons on submit and only re-enables them for
    // real (non-prevented) submissions, so restore it ourselves — otherwise
    // "Add note" stays disabled and blocks adding another note.
    const submitButton = this.element.querySelector('form [type=submit]')

    const token = this.csrfToken()
    try {
      const response = await fetch(this.formTarget.action, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-CSRF-Token': token },
        body: new FormData(this.formTarget)
      })
      const json = await response.json()

      if (json.success) {
        this.errorsTarget.classList.add('hidden')
        this.errorsTarget.innerHTML = ''

        // Refresh the notes list inside the modal.
        const current = this.element.querySelector('ul#job-notes') || this.element.querySelector('.no-job-notes')
        const template = document.createElement('template')
        template.innerHTML = json.notes_html
        if (current) current.replaceWith(template.content.firstElementChild.cloneNode(true))

        // Refresh the notes row under the job in the work list table.
        this.updateTableRow(json.notes_row_html)

        // Update the trigger label ("Edit notes" / "Add notes").
        const link = this.element.querySelector('a.edit-notes')
        if (link) link.textContent = json.has_notes ? 'Edit notes' : 'Add notes'

        const editor = window.tinymce && window.tinymce.get(`job_note_content_${this.jobIdValue}`)
        if (editor) editor.setContent('')
      } else {
        this.errorsTarget.innerHTML = json.errors_html
        this.errorsTarget.classList.remove('hidden')
      }
    } finally {
      if (submitButton) submitButton.disabled = false
    }
  }

  updateTableRow(html) {
    const jobRow = document.querySelector(`table tr#job-${this.jobIdValue}`)
    const notesRow = document.querySelector(`table tr#job-${this.jobIdValue}-notes`)

    if (html) {
      const template = document.createElement('template')
      template.innerHTML = html
      const newRow = template.content.firstElementChild
      if (jobRow && jobRow.classList.contains('odd')) newRow.classList.add('odd')
      if (notesRow) {
        notesRow.replaceWith(newRow)
      } else if (jobRow) {
        jobRow.after(newRow)
      }
    } else if (notesRow) {
      notesRow.remove()
    }
  }

  csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || ''
  }
}
